module.exports = __webpack_public_path__ + "static/media/onvego.2cb3174e.svg";